export default __webpack_public_path__ + "static/upiIdVerfHero-e57b1e2484663ae94f3cf7e674d542d0.webm";